import { ArrowUpRight, Menu, X } from "lucide-react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import LogoMark from "@/components/LogoMark";

const navItems = [
  ["Home", "/", "nav-link-home"],
  ["About", "/about", "nav-link-about"],
  ["Services", "/services", "nav-link-services"],
  ["Industries", "/industries", "nav-link-industries"],
  ["Contact", "/contact", "nav-link-contact"],
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => setMenuOpen(false), [location.pathname]);

  return (
    <header className="site-header" data-testid="site-header">
      <div className="container header-inner">
        <Link to="/" className="brand-link" data-testid="brand-home-link" aria-label="Vortex Core home">
          <LogoMark />
        </Link>
        <nav className={`main-nav ${menuOpen ? "is-open" : ""}`} aria-label="Main navigation">
          {navItems.map(([label, path, testId]) => (
            <NavLink key={path} to={path} end={path === "/"} className={({ isActive }) => `nav-link ${isActive ? "is-active" : ""}`} data-testid={testId}>
              {label}
            </NavLink>
          ))}
        </nav>
        <Link to="/contact" className="header-cta" data-testid="nav-cta-rfp">
          Start a conversation <ArrowUpRight size={15} strokeWidth={2.2} />
        </Link>
        <button type="button" className="menu-toggle" onClick={() => setMenuOpen((open) => !open)} aria-expanded={menuOpen} aria-label={menuOpen ? "Close navigation" : "Open navigation"} data-testid="mobile-menu-toggle">
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
    </header>
  );
}
